
export const cabinet = {
    namespaced: true,
    state: () => ({
        data: {}
    }),
    mutations: {
        setData(state,data){
            state.data = data;
            // console.log(data);
        },
        resetData(state){
            const size = Object.keys(state.data).length;
            if(size){
                for (const key in state.data){
                    delete state.data[key]
                }
            }
        }
        // установка выбора ячейки
        // selectCellCabinet(state,d) {
        //     let old = state.data.cabinetsPrices[d.officeId][d.cabinetId][d.index];
        //     state.data.cabinetsPrices[d.officeId][d.cabinetId][d.index] = Object.assign({},old,{select:d.value})
        // }
    },
    actions: {
        setData({ commit }, data) {
            // commit("resetData");
            commit("setData", data.cabinetsData);
        },
    }
};

